import axios from 'axios';
import { useCallback } from 'react';

export function useProofFileDownload() {
  const downloadFile = useCallback(async (fileId: number, filename: string, entity: string) => {
    const response = await axios.get(`/proof-file/${entity}/file/${fileId}/download`, {
      responseType: 'blob',
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }, []);

  return { downloadFile };
}
